import React from 'react';
import { observer } from 'mobx-react';

// Components
import * as icons from '../Icons/Icons';

const Modal = observer(class Modal extends React.Component {
  constructor() {
    super();

    // Bind this to functions
    this.closeModal = this.closeModal.bind(this);
    this.clickModal = this.clickModal.bind(this);
  }

  componentDidMount() {
    // Focus to close button when mounted
    const closeBtn = document.getElementById('modal__close');
    closeBtn.focus();

    document.addEventListener('keydown', this.clickModal)
  }

  componentWillUnmount() {
    //Remove Event Listener on unmount
    document.removeEventListener('keydown', this.clickModal);
  }

  // Had to declare function to click so it could properly remove event listener
  clickModal(e) {
    const closeBtn = document.getElementById('modal__close');

    if (e.key === 'Escape') {
      closeBtn.click();
    }
  }

  closeModal() {
    const { SessionStore } = this.props.store;

    SessionStore.modalContent = null;
    SessionStore.modalLoaded = false;
    SessionStore.modalSmall = false;
    SessionStore.modalShort = false;
    SessionStore.modalMediumShort = false;
    SessionStore.modalHeader = null;
    SessionStore.hideTimes = false;




    // Focus last element (if there was) when closing modal
    if (SessionStore.lastFocused) {
      SessionStore.lastFocused.focus();
      SessionStore.lastFocused = null;
    }
  }

  render() {
    const { SessionStore } = this.props.store;

    return (
      <div className={`modal ${!SessionStore.modalLoaded ? 'hidden' : ''}`}>
        <div className={`modal__window ${SessionStore.modalSmall ? 'modal__window--alt' : ''} ${SessionStore.modalShort ? 'modal__window--short' : ''}  ${SessionStore.modalMediumShort ? 'modal__window--medium-short' : ''}`}>
          <header className="modal__head">
            {SessionStore.modalHeader &&
              <h2>{SessionStore.modalHeader}</h2>
            }
            {!SessionStore.hideTimes &&
              <button
                className="modal__close"
                onClick={this.closeModal}
                id="modal__close"
              >
                <icons.iconTimes />
                <span className="meta">Close</span>
              </button>
            }

          </header>

          {SessionStore.modalContent}
        </div>
      </div>
    )
  }
})

export default Modal;



// WEBPACK FOOTER //
// ./src/app/components/Common/Modal.js